import { createAction } from "@reduxjs/toolkit";

export const apiCall = createAction<any>("api/call");

export const apiMediaCall = createAction<any>("api/Mediacall");
